module.exports = __webpack_public_path__ + "static/media/login.cbd37491.svg";